<template>
  <van-field :label="label" :value="value" readonly size="large" />
</template>
<script>
export default {
  props: {
    label: [String],
    value: [String],
  },
};
</script>
